import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NgIf } from '@angular/common';
import { CdkMenuItem, CdkMenuItemCheckbox } from '@angular/cdk/menu';
import { XToggleComponent } from '../x-toggle/x-toggle.component';
import { XBadgeComponent } from '../x-badge/x-badge.component';

@Component({
  selector: 'app-x-menu-item',
  standalone: true,
  imports: [SvgIconComponent, NgIf, CdkMenuItem, CdkMenuItemCheckbox, XToggleComponent, XBadgeComponent],
  templateUrl: './x-menu-item.component.html',
  styleUrl: './x-menu-item.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XMenuItemComponent {
  @Input() active: boolean = false;
  @Input() submenu: boolean = false;
  @Input() withSelectIcon: boolean = false;
  @Input() leadingIcon: string | undefined;
  @Input() trailingIcon: string | undefined;

  @Input() isToggle: boolean = false;
  @Input() toggleValue: boolean = false;
  @Input() showNewBadge: boolean = false;

  @Output() toggleChange = new EventEmitter<boolean>();

  @HostBinding('class.disabled') @Input() disabled: boolean | undefined = false;

  public onToggleClick(event: MouseEvent) {
    if (!this.isToggle) {
      return;
    }

    this.toggleValue = !this.toggleValue;
    this.toggleChange.emit();
    event.stopPropagation();
  }
}
